import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SEMINAR_INFORMATION_DATA_TYPE_VIEW, SEMINAR_INFORMATION_DATA_TYPE_PREVIEW, } from '../../../../../define/consts/seminar/seminar_information';
import { propBool, propFunc, propId, } from '../../../../../helpers/custom-prop-types';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
const SeminarOneSticky = (props) => {
    const { dataType, id, isCloning, isDisabled, isSelf, onClickSave, onClone, submitting, } = props;
    return (_jsx("div", Object.assign({ className: 'sticky-footer professional_seminar_one_sticky' }, { children: _jsx("div", Object.assign({ className: 'footer-action professional_seminar_one_sticky_inner' }, { children: isSelf ? (_jsxs(_Fragment, { children: [_jsx(SubmitButton, { buttonType: 'button', className: 'link-text professional_seminar_one_sticky_preview', isDisabled: isDisabled, isLoading: dataType === SEMINAR_INFORMATION_DATA_TYPE_PREVIEW.value &&
                            submitting, onControlClick: onClickSave, tabIndex: 0, text: 'プレビューを見る', value: SEMINAR_INFORMATION_DATA_TYPE_PREVIEW.value }), _jsx(SubmitButton, { buttonType: 'button', className: 'button service professional_seminar_one_sticky_submit', isDisabled: isDisabled, isLoading: dataType === SEMINAR_INFORMATION_DATA_TYPE_VIEW.value &&
                            submitting, onControlClick: onClickSave, tabIndex: 0, text: '保存する', value: SEMINAR_INFORMATION_DATA_TYPE_VIEW.value })] })) : (_jsx(SubmitButton, { buttonType: 'button', className: 'button service professional_seminar_one_sticky_submit', isDisabled: isDisabled, isLoading: isCloning, onControlClick: onClone, tabIndex: 0, text: '複製する', value: id })) })) })));
};
SeminarOneSticky.propTypes = {
    dataType: propId(),
    id: propId(),
    isCloning: propBool().isRequired,
    isDisabled: propBool().isRequired,
    isSelf: propBool().isRequired,
    onClickSave: propFunc().isRequired,
    onClone: propFunc().isRequired,
    submitting: propBool(),
};
SeminarOneSticky.defaultProps = {
    dataType: undefined,
    id: null,
    submitting: false,
};
export default SeminarOneSticky;
